import React from 'react';
import BadgeTier from './SellerBadge';

/**
 * DealerBadge — thin backwards-compatible wrapper over the unified
 * `<BadgeTier tier="dealer">` from SellerBadge.js.
 *
 * iter121 — renamed platform-wide from "Verified Dealer" → "Trusted Dealer".
 * All shield colour / shape / typography now matches Verified User + Trusted
 * Seller (per spec: only colour + title differ across tiers).
 */
const VARIANT_SIZE = { card: 'sm', detail: 'md', seller: 'lg' };

const DealerBadge = ({ variant = 'card', testId = 'dealer-badge' }) => (
  <BadgeTier tier="dealer" size={VARIANT_SIZE[variant] || 'sm'} testId={testId} />
);

export default DealerBadge;
